var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-image',_vm._b({staticStyle:{"max-width":"120px"},attrs:{"src":_vm.src}},'b-image',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }